var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-name-tree-container", style: _vm.containerStyle },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.svgWidth,
            height: _vm.svgHeight,
            viewBox: "0 0 44 60",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("title", [_vm._v("aiNameTree")]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "首页",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "首页-ai选题-已生成",
                    fill: _vm.fillColor,
                    stroke: _vm.strokeColor,
                    "stroke-width": "1.5"
                  }
                },
                [
                  _c("g", { attrs: { id: "编组-69" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M33.9222397,0.443300199 C28.8453711,0.747260942 25.3314146,6.72926636 23.3803701,18.3893164 C21.7024913,24.3827011 17.7572755,27.6446087 11.5447226,28.1750392 C11.4266653,28.185119 7.58107052,28.1980193 0.0079382015,28.2137402 L0,29.1679613 C7.59806351,29.055212 11.4611877,28.9991551 11.5893726,28.9997907 C14.6557585,29.0149932 17.3319695,28.2022058 19.6180056,26.5614283 C22.0473873,24.8177661 23.6761941,22.0937288 24.5044261,18.3893164 C25.3328808,14.3610241 26.2396391,11.0829086 27.2247008,8.55496987 C28.5381374,5.18433119 30.1072492,3.06130543 32.8565109,1.55292448 C33.2001194,1.36440389 33.6691413,1.193759 34.09091,1.17742861 L41.2119445,0.904823436 C41.2122578,0.484284716 41.2095941,0.18414793 41.2039531,0.0044130781 C39.8898624,-0.0280158328 37.4626246,0.118279874 33.9222397,0.443300199 Z",
                        id: "路径-7"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M33.9222397,29.4433002 C28.8453711,29.7472609 25.3314146,35.7292664 23.3803701,47.3893164 C21.7024913,53.3827011 17.7572755,56.6446087 11.5447226,57.1750392 C11.4266653,57.185119 7.58107052,57.1980193 0.0079382015,57.2137402 L0,58.1679613 C7.59806351,58.055212 11.4611877,57.9991551 11.5893726,57.9997907 C14.6557585,58.0149932 17.3319695,57.2022058 19.6180056,55.5614283 C22.0473873,53.8177661 23.6761941,51.0937288 24.5044261,47.3893164 C25.3328808,43.3610241 26.2396391,40.0829086 27.2247008,37.5549699 C28.5381374,34.1843312 30.1072492,32.0613054 32.8565109,30.5529245 C33.2001194,30.3644039 33.6691413,30.193759 34.09091,30.1774286 L41.2119445,29.9048234 C41.2122578,29.4842847 41.2095941,29.1841479 41.2039531,29.0044131 C39.8898624,28.9719842 37.4626246,29.1182799 33.9222397,29.4433002 Z",
                        id: "路径-7",
                        transform:
                          "translate(20.605972, 43.583981) scale(1, -1) translate(-20.605972, -43.583981) "
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-00f1c22f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-00f1c22f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-name-tree/ai-name-tree.vue
// module id = null
// module chunks = 